export default "__VITE_ASSET__BDSrf8_C__"